import React, { Component, PropTypes } from 'react'
import styled from 'styled-components'
import R from 'ramda'
import Grid from 'grid-styled'
import { translate } from 'react-i18next'
import AdminNavbar from '../../components/AdminNavbar'
import Input from '../../components/Input'
import { validateInput, validateForm } from '../../Utils/Validations'
import { adminDefault } from '../../Utils/Defaults'
import CardContainer from '../../components/CardContainer'
import BackArrow from '../../svg-icons/BackArrow'
import { Metrics, Fonts } from '../../Themes'
import ThemeContainer from '../../components/ThemeContainer'
import {
  deleteAdmin,
  createAdmin,
  updateAdmin,
  searchAdmins
} from '../../sources/AdminSource'
import SuccessModal from '../../components/Modal/SuccessModal'
import ErrorModal from '../../components/Modal/ErrorModal'
import DialogModal from '../../components/Modal/DialogModal'

const PageContainer = styled.div`min-height: 100%;`

const CustomCardContainer = styled(CardContainer)`
  margin-top: ${Metrics.margins.base};
`

const CustomThemeContainer = styled(ThemeContainer)`
  padding-left: ${Metrics.components.customThemeSpacing} !important;
  padding-right: ${Metrics.components.customThemeSpacing} !important;
  max-height: ${Metrics.components.adminContent};
  overflow-y: scroll;
`

const ArrowContainer = styled.div`
  margin-top: ${Metrics.margins.base};
  margin-bottom: ${Metrics.margins.base};
  cursor: pointer;

  span {
    padding-left: ${Metrics.margins.medium};
    ${Fonts.style.Header};
  }
`

const CustomGrid = styled(Grid)`
  margin-top: ${props => (props.noPadTop ? 0 : Metrics.margins.base)};
  padding-left: ${props => (props.noPadLeft ? 0 : Metrics.margins.medium)};
  padding-right: ${props => (props.noPadRight ? 0 : Metrics.margins.medium)};
`

class EditAdmin extends Component {
  constructor (props) {
    super(props)
    this.state = {
      create: false,
      adminToUpdate: R.clone(adminDefault),
      modal: false,
      errors: R.clone(adminDefault),
      password: '',
      passwordError: '',
      passwordConfirmation: ''
    }

    this.handleChange = this.handleChange.bind(this)
    this.handlePasswordChange = this.handlePasswordChange.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.handlePasswordBlur = this.handlePasswordBlur.bind(this)
  }

  componentWillMount () {
    const { id } = this.props.params
    if (id !== 'new') {
      searchAdmins({ id })
        .then(response => this.setState({ adminToUpdate: response.data }))
        .catch(error => console.log(error))
    } else {
      this.setState({ create: true })
    }
  }

  handleChange (event, key) {
    const { adminToUpdate } = this.state
    adminToUpdate[key] = event.target.value
    this.setState({ adminToUpdate })
  }

  handlePasswordChange (event, key) {
    const state = this.state
    state[key] = event.target.value
    this.setState({ state })
  }

  handleDelete () {
    const { router } = this.props
    deleteAdmin(this.state.adminToUpdate.id)
      .then(response => router.goBack())
      .error(error => {
        console.log(error)
        this.toggleModal('error')
      })
  }

  handleBlur (name, value, errors) {
    let newErrors = validateInput(name, value, errors)
    this.setState({ errors: newErrors })
  }

  handlePasswordBlur () {
    const { t } = this.props
    const { password, passwordConfirmation } = this.state
    this.setState({
      passwordError:
        passwordConfirmation !== password ? t(`Passwords don't match`) : ''
    })
  }

  handleSubmit () {
    const { t } = this.props
    const {
      create,
      adminToUpdate,
      passwordConfirmation,
      password,
      errors
    } = this.state
    let validation = validateForm(adminToUpdate, errors)
    if (validation.valid && passwordConfirmation === password) {
      if (create) {
        if (password.length > 0) {
          let admin = Object.assign({}, adminToUpdate, { password })
          createAdmin(admin)
            .then(response => this.toggleModal('success'))
            .catch(error => {
              console.log(error)
              this.toggleModal('error')
            })
        } else {
          this.setState({ passwordError: t('This field is Required') })
        }
      } else {
        let admin = adminToUpdate
        if (password.length > 0 && password === passwordConfirmation) {
          admin = Object.assign({}, adminToUpdate, { password })
        }
        updateAdmin(admin)
          .then(response => this.toggleModal('success'))
          .catch(error => {
            console.log(error)
            this.toggleModal('error')
          })
      }
    }
  }

  toggleModal (modal) {
    this.setState({ modal })
  }

  render () {
    let {
      adminToUpdate,
      create,
      passwordConfirmation,
      password,
      modal,
      errors,
      passwordError
    } = this.state

    const { t, admin, dropdownLinks, router } = this.props

    const actions = [
      { label: t('Save'), primary: true, onClick: this.handleSubmit }
    ]
    if (!create && admin.email !== adminToUpdate.email) {
      actions.push({
        label: t('Delete Admin'),
        secondary: true,
        onClick: () => this.toggleModal('dialog')
      })
    }

    return (
      <PageContainer>
        <AdminNavbar
          admin={admin}
          dropdownLinks={dropdownLinks}
          rightSideActions={actions}
        />
        <ErrorModal
          visible={modal === 'error'}
          message={t(
            `There was an error on ${create
              ? 'creating'
              : 'updating'} the admin`
          )}
          closeAction={this.toggleModal}
          header={t('Error')}
        />
        <SuccessModal
          visible={modal === 'success'}
          message={t(
            `The admin was successfully ${create ? 'created' : 'updated'}`
          )}
          closeAction={this.toggleModal}
          header={t('Admin Updated')}
        />
        <DialogModal
          visible={modal === 'dialog'}
          message={t('Do you really want to delete the admin?')}
          closeAction={this.toggleModal}
          header={t('Delete Admin')}
          buttons={{
            apply: { label: t('Delete'), onClick: this.handleDelete },
            cancel: { label: t('Cancel'), onClick: this.toggleModal }
          }}
        />
        <CustomThemeContainer>
          <ArrowContainer onClick={() => router.goBack()}>
            <BackArrow />
            <span>{create ? t('Insert Admin') : adminToUpdate.name}</span>
          </ArrowContainer>
          <CustomCardContainer title={t('Personal Info')}>
            <CustomGrid noPadTop noPadLeft noPadRight>
              <CustomGrid xs={1 / 2} noPadTop noPadLeft>
                <Input
                  required
                  name='name'
                  placeholder={t('Name')}
                  title={t('Name')}
                  handleChange={event => this.handleChange(event, 'name')}
                  value={adminToUpdate.name}
                  error={errors['name']}
                  handleBlur={() =>
                    this.handleBlur('name', adminToUpdate.name, errors)}
                />
              </CustomGrid>
              <CustomGrid xs={1 / 2} noPadTop noPadRight>
                <Input
                  name='email'
                  required
                  placeholder={t('E-mail')}
                  title={t('E-mail')}
                  handleChange={event => this.handleChange(event, 'email')}
                  value={adminToUpdate.email}
                  error={errors['email']}
                  handleBlur={() =>
                    this.handleBlur('email', adminToUpdate.email, errors)}
                />
              </CustomGrid>
            </CustomGrid>
          </CustomCardContainer>
          <CustomCardContainer title={t('Change Password')}>
            <CustomGrid noPadTop noPadLeft noPadRight>
              <CustomGrid xs={1 / 2} noPadTop noPadLeft>
                <Input
                  type='password'
                  placeholder={t('Password')}
                  title={t('Password')}
                  handleChange={event =>
                    this.handlePasswordChange(event, 'password')}
                  value={password}
                  error={passwordError}
                  handleBlur={this.handlePasswordBlur}
                />
              </CustomGrid>
              <CustomGrid xs={1 / 2} noPadTop noPadRight>
                <Input
                  type='password'
                  placeholder={t('Confirm Password')}
                  title={t('Confirm Password')}
                  handleChange={event =>
                    this.handlePasswordChange(event, 'passwordConfirmation')}
                  value={passwordConfirmation}
                  handleBlur={this.handlePasswordBlur}
                />
              </CustomGrid>
            </CustomGrid>
          </CustomCardContainer>
        </CustomThemeContainer>
      </PageContainer>
    )
  }
}

EditAdmin.propTypes = {
  t: PropTypes.func,
  params: PropTypes.object,
  admin: PropTypes.object,
  dropdownLinks: PropTypes.array,
  router: PropTypes.object
}

export default translate([ 'common', 'admin', 'forms' ], { wait: true })(
  EditAdmin
)



// WEBPACK FOOTER //
// ./src/pages/AdminAdmins/EditAdmin.js